import {
  saveUser,
  loadUser,
  saveCart,
  loadCart,
  loadBankCard,
  saveCardStatus,
  savePcodeNum,
  loadPcode,
  loadPic,
  savePic,
  removeBankCard,
  removeUser,
  loadAgentStatus,
  saveAgentStatus,
} from "../cache";
import authentication from "../../api/authentication/index";
import * as types from "./mutation-types";
import Vue from "vue";
const state = {
  userInfo: loadUser(),
  cartInfo: loadCart(),
  bankCardStatus: loadBankCard(),
  codeInfo: loadPcode(), //pcode
  activityPic: loadPic(), //pcode
  agentShow: loadAgentStatus(),
};
const mutations = {
  [types.SET_USER_INFO](state, obj) {
    state.userInfo = obj;
  },
  [types.UPDATE_CART_QUANTITY](state, obj) {
    state.cartInfo = obj;
  },
  [types.SAVE_BANK_STATUS](state, obj) {
    state.bankCardStatus = obj;
  },
  [types.REMOVE_BANK_CARD]() {
    state.bankCardStatus = {};
  },
  [types.SAVE_UPDATE_PCODE](state, obj) {
    state.codeInfo = obj;
  },
  [types.SAVE_PAGE](state, obj) {
    state.activityPic = obj;
  },
  [types.AGENT_SHOW](state, obj) {
    state.agentShow = obj;
  },
  [types.REMOVE_USER]() {
    state.userInfo = {};
  },
};

const actions = {
  login({
    commit
  }, obj) {
    return new Promise((resolve, reject) => {
      authentication
        .wxLogin()
        .then((res) => {
          if (res.status === 200) {
            let data = res.data;
            commit(
              types.SET_USER_INFO,
              saveUser({
                // phoneNumber: obj.phoneNumber,
                isLogin: true,
                userId: data.userId,
                token: data.token,
                // cartQuantity: data.cartQuantity,
                weChatAccountInfo: data.weChatAccount,
                isEmployee: data.isEmployee,
                employeeInfo: data.employee,
                isOwner: data.isOwner,
                ownerInfo: data.owner,
                userStatusId: data.userStatusId,
              })
            );
            resolve(res);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  wxLogin({
    commit
  }, obj) {
    return new Promise((resolve, reject) => {
      var userInfo = obj;
      console.log(userInfo);
      // var conn = signaRHub(userInfo.userId);
      // app.__vue__.$signalConnection = signaRHub(obj.userId);
      // Vue.prototype.$signalConnection = conn;
      commit(
        types.SET_USER_INFO,
        saveUser({
          isLogin: true,
          userId: userInfo.userId,
          token: userInfo.token,
          avatarUrl: userInfo.avatarUrl,
          nickName: userInfo.nickName,
          phoneNumber: userInfo.phoneNumber,
          shareCode: userInfo.shareCode,
          userType: userInfo.identityType,
          statusName: userInfo.identityStatus, //判断状态
          openId: userInfo.openId,
          shareCodeImageUrl: userInfo.shareCodeImageUrl == null || userInfo.shareCodeImageUrl == '' ? '' : userInfo.shareCodeImageUrl,
          cartQuantity: '',
          isUserBindActivity:userInfo.isUserBindActivity,
          isSaleIdentity:userInfo.isSaleIdentity,
          salesApprovalQuantity:userInfo.salesApprovalQuantity,
          salesUpgradePartnerApprovalQuantity:userInfo.salesUpgradePartnerApprovalQuantity,
        })
      );
      resolve();
    });
  },
  // 登录缓存首页活动
  PageLogin({
    commit
  }, obj) {
    commit(types.SAVE_PAGE, savePic({
          isShowPageActivity:obj.isShowPageActivity,
          picUrl:obj.picUrl,
          picChildUrl:obj.picChildUrl,
    }));
  },
  signOut({
    commit
  }) {
    commit(types.REMOVE_USER, removeUser());
  },
  updateUserCartQuantity({
    commit
  }, quantity) {
    let cartInfo = quantity;
    commit(types.UPDATE_CART_QUANTITY, saveCart(cartInfo));
  },
  updatePcode({
    commit
  }, quantity) {

    console.log(quantity,'num')
    commit(types.SAVE_UPDATE_PCODE , savePcodeNum({
      availableNum: quantity.available?quantity.available:0,
      usableNum: quantity.usable?quantity.usable:0
    }));
  },
  saveBankStatus({
    commit
  }, status) {
    commit(types.SAVE_BANK_STATUS, saveCardStatus({
      saveStatus: status.save,
      status: status.cardStatus,
      isShow: status.IsShow,
      color:status.color
    }));
  },
  buyAgentStatus({
    commit
  }, status) {
    commit(types.AGENT_SHOW, saveAgentStatus({
      isShow: status.show,
      status: status.type,
      address:status.address
    }));
  },
  statusOut({
    commit
  }) {
    commit(types.REMOVE_BANK_CARD, removeBankCard());
  },
};

const getters = {
  userInfo: (state) => state.userInfo,
  cartInfo: (state) => state.cartInfo,
  bankCardStatus: (state) => state.bankCardStatus,
  codeInfo: (state) => state.codeInfo,
  activityPic: (state) => state.activityPic,
  agentShow: (state) => state.agentShow,
};

export default {
  state,
  mutations,
  actions,
  getters,
};